
import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Login from "./Login";
import TawkTo from "tawkto-react";
import ExportApi from "../../src/api/ExportApi";
import { BsYoutube } from "react-icons/bs";
import FooterSignupForm from "./FooterSignupForm";

export default function Footer() {
  const [show, setShow] = useState(false);
  const [shownew, setShownew] = useState(false);
  const [email, setEmail] = useState("");
  const [forgot, setForgot] = useState(false);
  const [signup, setSignup] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const tokenUser = localStorage.getItem("tokenuser");
  const tokenAdmin = localStorage.getItem("admin");
  const userIdnew = JSON.parse(tokenUser);
  const tokenpic = localStorage.getItem("load");

  const handleShow = () => {
    if (!tokenUser) {

      setShow(true);
    } else {
      setShow(false);
    }
  };

  const newhandleShow = () => setShownew(true);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleClose = () => setShow(false);
  const handleClosenew = () => setShownew(false);

  const getApiKeyDecode = async () => {
    try {
      const response = await ExportApi.gettawk();
      return response.data;
    } catch (error) {
      console.error("Error fetching API key:", error);
      throw new Error("Failed to retrieve API key");
    }
  };

  const openTawkToPopup = async () => {
    try {
      const { propertyId, key } = await getApiKeyDecode();

      const tawkToInstance = new TawkTo(propertyId, key);

      tawkToInstance.toggle();
    } catch (error) {
      console.error("Error opening Tawk.to popup:", error);
    }
  };


  const paramValue = new URLSearchParams(location.search).get("contactus");

  if (paramValue === "true" && tokenpic === "true") {
    openTawkToPopup();
  }

  return (

    <div className="footer" id="footer" style={{ minHeight: "300px", overflowAnchor: 'none' }}>
      <Container>
        <div style={{ minHeight: "150px" }}> 
        <FooterSignupForm
          handleEmailChange={handleEmailChange}
          handleShow={handleShow}
          tokenUser={tokenUser}
          tokenAdmin={tokenAdmin}
          userIdnew={userIdnew}
        />
        </div>

        <div className="py-4">
          <span className="custom-border"></span>
          <Row>
            {/* Left Column - Account Links */}
            <Col xs={12} md={4}>
              <div className="nav-list mb-3 md:ms-5">
                <div className="d-flex flex-column">

                  <Link
                    onClick={!userIdnew?.id ? newhandleShow : undefined}
                    to={userIdnew?.id ? `/profile/${userIdnew?.id}` : "#"}
                    className="fs-5 fw-bold text-dark mb-2"
                  >
                    My Account
                  </Link>
                </div>

                <div className="d-flex flex-column">
                  {["selling", "buying", "pending", "history"].map((type) => (
                    <Link
                      key={type}
                      onClick={!userIdnew?.id ? newhandleShow : undefined}
                      to={userIdnew?.id ? `/buySellManagment/${type}` : "#"}
                      className="fs-5 fw-medium text-dark"
                    >
                      {type.charAt(0).toUpperCase() + type.slice(1)}
                    </Link>
                  ))}
                  <Link

                    onClick={!userIdnew?.id ? newhandleShow : undefined}
                    to={userIdnew?.id ? `/profile/${userIdnew?.id}` : "#"}
                    className="fs-5 fw-medium text-dark"
                  >

                    User Info
                  </Link>
                  <Link
                    onClick={!userIdnew?.id ? newhandleShow : undefined}
                    to={userIdnew?.id ? `/stripeconnectaccount/${userIdnew?.id}` : "#"}
                    className="fs-5 fw-medium text-dark"
                  >

                    Payments and Payouts
                  </Link>
                </div>
              </div>
            </Col>

            {/* Middle Column - Social Media */}
            <Col
              xs={12}
              md={4}
              className="center-section d-flex align-items-center justify-content-center flex-column"
            >
              <ul className="list-unstyled d-flex justify-content-center flex-wrap align-items-center mb-5">
                <li className="me-4">
                  <Link to="https://www.youtube.com/@gpuwiz" target="_blank">
                    <BsYoutube size={50} color="#FE0000" />
                  </Link>
                </li>
                {[
                  {
                    href: "https://twitter.com/gpu_wiz",
                    src: "https://gpu-wiz.s3.us-west-1.amazonaws.com/socialicons/1744962445143_devicon_twitter.svg",
                    alt: "Twitter"
                  },
                  {
                    href: "https://www.instagram.com/gpuwiz/",
                    src: "https://gpu-wiz.s3.us-west-1.amazonaws.com/socialicons/1744961289286_instagram-2-1-logo-svgrepo-com.svg",
                    alt: "Instagram"
                  },
                  {
                    href: "https://www.tiktok.com/@gpuwiz?lang=en",
                    src: "https://gpu-wiz.s3.us-west-1.amazonaws.com/socialicons/1744962160198_lineicons_tiktok-alt.svg",
                    alt: "TikTok"
                  },
                  {
                    href: "https://www.facebook.com/profile.php?id=61556017664988",
                    src: "https://gpu-wiz.s3.us-west-1.amazonaws.com/socialicons/1744961389462_facebook-svgrepo-com.svg",
                    alt: "Facebook"
                  }
                ].map(({ href, src, alt }) => (
                  <li className="me-4" key={alt}>
                    <Link to={href} target="_blank">
                      <img src={src} alt={alt} width={40} height={40} />
                    </Link>
                  </li>
                ))}
              </ul>
              <p className="text-center fw-bold text-dark fs-5 mb-2">Los Angeles, CA</p>
              <p className="text-center fw-medium text-dark fs-5">
                ©{new Date().getFullYear()} gpuwiz | All Rights Reserved.
              </p>
            </Col>

            {/* Right Column - Help & Policies */}
            <Col xs={12} md={4}>
              <div className="nav-list mb-0 md:ms-5">
                <div className="mb-2 fs-5 fw-bold">
                  <Link
                    to="/help"
                    onClick={() => {
                      localStorage.setItem("activeText", "Quality Standards");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-dark"
                  >
                    Help
                  </Link>

                </div>
                <div className="d-flex flex-column">
                  {[
                    { text: "Quality Standards", to: "/help/quality-standards" },
                    { text: "Pre-Sale Inspection Guide", to: "/help/pre-sale-inspection-guide" },
                    { text: "Buying and Selling Guide", to: "/help/buying-and-Selling-Guide" },
                    { text: "Shipping Instructions", to: "/help/shipping-instructions" },
                    { text: "Terms of Service", to: "/terms" },
                    { text: "Privacy Policy", to: "/PrivacyPolicy" },
                    { text: "Cookie Policy", to: "/cookies" }
                  ].map(({ text, to }) => (
                    <Link
                      key={text}
                      to={to}
                      target="_blank"
                      onClick={() => {
                        localStorage.setItem("activeText", text);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      className="d-inline text-dark fs-5 fw-medium"
                    >
                      {text}
                    </Link>
                  ))}
                  <button
                  style={{ fontFamily: "panton"}}
                    onClick={openTawkToPopup}
                    className="text-start bg-none border-0 p-0 d-inline text-dark fs-5 fw-medium"
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Modals */}

      <Login
        setSignup={setSignup}
        setForgot={setForgot}
        signup={signup}
        forgot={forgot}
        modal={() => setShow(false)}
        show={show}
        setShow={setShow} />
    </div>
  );
}

